if (!customElements.get("product-services")) {
  customElements.define(
    "product-services",
    class ProductServices extends UpsellSlider {
      constructor() {
        super();
        this.autoPlay = {
          delay: 2000,
        };
        this.spaceBetween = 5;
      }
    }
  );
}
if (!customElements.get("related-products-preview-slider")) {
  customElements.define(
    "related-products-preview-slider",
    class RelatedProductsPreviewSlider extends HTMLElement {
      constructor() {
        super();
        this.sliderRef = this.querySelector("[data-slider]");
        this.nextRef = this.querySelector('[data-navigation="next"]') || null;
        this.previousRef = this.querySelector('[data-navigation="prev"]') || null;
        this.paginationRef = this.querySelector("[data-pagination]") || null;
        this.initSlider = this.initSlider.bind(this);
        this.autoPlay = false;
        this.spaceBetween = 10;
      }

      connectedCallback() {
        this.initSlider();
      }

      initSlider() {
        this.swiper = new Swiper(this.sliderRef, {
          // Optional parameters
          loop: false,
          spaceBetween: this.spaceBetween,
          autoplay: this.autoPlay || false,
          slidesPerView: "auto",
          spaceBetween: 8,

          keyboard: {
            enabled: true,
          },

          // If we need pagination
          pagination: {
            el: this.paginationRef,
            clickable: true,
          },

          // Navigation arrows
          navigation: {
            nextEl: this.nextRef,
            prevEl: this.previousRef,
          },
        });
      }

      disconnectedCallback() {
        this.swiper.destroy();
      }
    }
  );
}

function scroll_stick_add_to_cart() {
  if (window.innerWidth < 769) {
    var addtoCartBtns = document.querySelectorAll(".add-to-cart.btn");

    if (addtoCartBtns.length > 0) {
      var addtocartWrapper = document.querySelector(".addtocart--wrp");
      addtocartWrapper.classList.remove("fixed_sticky");

      var scroll = window.scrollY || document.documentElement.scrollTop;

      var elemTop = addtocartWrapper.getBoundingClientRect().top + window.scrollY;
      var elemBottom = elemTop + addtocartWrapper.offsetHeight;

      if (scroll >= elemBottom || scroll + window.innerHeight <= elemBottom) {
        addtocartWrapper.classList.add("fixed_sticky");
        document.body.style.paddingBottom = addtocartWrapper.offsetHeight + "px";
      }
    }
  }
}

scroll_stick_add_to_cart();

window.addEventListener("scroll", function () {
  scroll_stick_add_to_cart();
});

if (!customElements.get("main-product-gallery")) {
  customElements.define(
    "main-product-gallery",
    class MainProductGallery extends HTMLElement {
      constructor() {
        super();
        this.mainSliderRef = this.querySelector("[data-main-slider]");
        this.thumbSliderRef = this.querySelector("[data-thumb-slider]");
        this.nextRef = this.querySelector('[data-navigation="next"]') || null;
        this.previousRef = this.querySelector('[data-navigation="prev"]') || null;
        this.paginationRef = this.querySelector("[data-pagination]") || null;
        this.magnifier = null;
        this.initSlider = this.initSlider.bind(this);
        this.handleVideoPlay = this.handleVideoPlay.bind(this);
        this.initZoom = this.initZoom.bind(this);
        this.handleZoomButton = this.handleZoomButton.bind(this);
        this.handleZoomMutationObserver = this.handleZoomMutationObserver.bind(this);
        //this.handleResize = this.handleResize.bind(this);
      }

      connectedCallback() {
        this.initSlider();
        this.handleVideoPlay();
        //this.handleResize();
        this.initZoom();
        this.handleZoomButton();
        this.handleZoomMutationObserver(); 
      }

      initSlider() {
        this.thumbSwiper = new Swiper(this.thumbSliderRef, {
          spaceBetween: 8,
          slidesPerView: "auto",
          grabCursor: true,
          mousewheel: true,
          direction: "vertical",
          watchOverflow: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          freeMode: true,
        });

        this.mainSwiper = new Swiper(this.mainSliderRef, {
          spaceBetween: 10,
          grabCursor: true,
          pagination: {
            el: this.paginationRef,
            clickable: true,
          },
          navigation: {
            nextEl: this.nextRef,
            prevEl: this.previousRef,
          },
          thumbs: {
            swiper: this.thumbSwiper,
          },
        });

        this.mainSwiper.on("slideChange", () => {
          //this.handleResize();
          this.initZoom();
          this.handleZoomButton();
        });
      }
      handleZoomMutationObserver() {
        const observer = new MutationObserver(() => {
          this.initZoom();
          this.handleZoomButton();
        });

        observer.observe(this.mainSliderRef, { childList: true, subtree: true });
      }
      handleVideoPlay() {
        this.mainSwiper.on("slideChangeTransitionStart", (swiper) => {
          const prevSlide = swiper.slides[swiper.previousIndex];
          const video = prevSlide?.querySelector("video");
          if (video) video.pause();
        });

        this.mainSwiper.on("slideChangeTransitionEnd", (swiper) => {
          const activeSlide = swiper.slides[swiper.activeIndex];
          const video = activeSlide?.querySelector("video");
          if (video) video.play();
        });
      }

      initZoom() {
        if (!this.mainSliderRef.dataset.zoom) return;
        if (this.magnifier) this.magnifier.style.display = "none";    
        const activeSlide = this.mainSwiper.slides[this.mainSwiper.activeIndex];
        const image = activeSlide.querySelector("img");
        if (!image) return;    
        this.magnifier = document.querySelector("[data-maginifier]");
        
        this.magnifierImg = this.magnifier.querySelector("img");
        this.magnifierImg.src = activeSlide.getAttribute("data-image");
        image.addEventListener("mousemove", (e) => this.handleZoom(e, image));
        image.addEventListener("mouseleave", () => (this.magnifier.style.display = "none"));
        image.addEventListener("mouseenter", () => (this.magnifier.style.display = "block"));
      }

      handleZoom(event, image) {
        const rect = image.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
    
        this.magnifierImg.style.transformOrigin = `${x}% ${y}%`;
        this.magnifierImg.style.transform = "scale(2.5)";
      }
      handleResize() {
        this.initZoom();
      }
      handleZoomButton() {
        const zoomButtons = document.querySelectorAll("[data-zoom-button]");
        if (!zoomButtons.length) return;

        zoomButtons.forEach((button) => {
          button.addEventListener("click", () => {
            const mediaId = button.getAttribute("data-media-id");
            const mediaElements = document.querySelectorAll(".global-media-settings");
            const nextElement = button.nextElementSibling;
            const customMedia = document.querySelector(".custom-media-src");
            document.body.classList.add("open-pdp-modal");

            mediaElements.forEach((media) => {
              if (media.getAttribute("data-media-id") === mediaId) {
                media.classList.add("active");
                if (customMedia) {
                  customMedia.classList.remove("active");
                } 
              } else {
                media.classList.remove("active");
                if (nextElement && nextElement.tagName === "IMG" && customMedia) {
                  const imageSrc = nextElement.getAttribute("src");
                  customMedia.setAttribute("src", imageSrc);
                  customMedia.classList.add("active");
                } 
              }
            });
          });
        });

        const closeButton = document.querySelector("[data-pdp-close]");
        if (!closeButton) return;

        closeButton.addEventListener("click", () => {
          document.body.classList.remove("open-pdp-modal");
        });
      }
      disconnectedCallback() {
        this.thumbSwiper.destroy();
        this.mainSwiper.destroy();
      }
    }
  );
}
